import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FiSearch } from "react-icons/fi";
import Highlighter from "react-highlight-words";

import { ScreenContainer, Input, Table } from "components";

import { actionLocationsGetAll, selectAllLocations } from "pages/locations/redux";

const LocationsList = () => {
  const oDispatch = useDispatch();
  const aLocations = useSelector(selectAllLocations);
  const [sFilter, setFilter] = useState("");
  const [aFilteredLocations, setFilteredLocations] = useState([]);

  useEffect(() => {
    oDispatch(actionLocationsGetAll());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setFilteredLocations(() => {
      return aLocations?.length
        ? aLocations
          .filter(oLocation => (oLocation.name?.toLowerCase().includes(sFilter.toLowerCase()) || oLocation.stateName?.toLowerCase().includes(sFilter.toLowerCase())))
          .map(oLocation => ({ ...oLocation, sFilter }))
        : [];
    });
  }, [aLocations, sFilter]);

  return (
    <ScreenContainer>
      <h1 className="ui-page-title self-center">
        Listado de localidades
      </h1>
      <section className="grid grid-cols-4 mt-4">
        <div className="relative col-span-4 md:col-span-1">
          <div className="absolute inset-y-0 left-0 flex items-center pl-2.5 pointer-events-none">
            <FiSearch className="w-4 h-4 text-gray-400" />
          </div>
          <Input
            withoutClass
            value={sFilter}
            floatLabel={false}
            onChange={setFilter}
            placeholder="Buscar"
            containerClassName="rounded-lg overflow-hidden"
            className="ui-field-icon w-full"
          />
        </div>
      </section>
      <section className="py-5">
        <Table data-testid={"LocationsTable"}>
          <Table.Header>
            <Table.Row isHeaderOrFooter>
              <Table.Col scope="col" className="px-3 py-2 text-center">
                #
              </Table.Col>
              <Table.Col scope="col" className="px-3 py-2 text-center">
                Nombre
              </Table.Col>
              <Table.Col scope="col" className="px-3 py-2 text-center hidden md:table-cell">
                Departamento
              </Table.Col>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {aFilteredLocations.length > 0 ? (
              aFilteredLocations.map((oLocation, nIndex) => (
                <Table.Row key={`${oLocation.id}_${nIndex}`}>
                  <Table.Col
                    scope="row"
                    className="text-xs md:text-sm px-3 py-2 font-medium text-gray-800 dark:text-white whitespace-nowrap text-center"
                  >
                    {nIndex + 1}
                  </Table.Col>
                  <Table.Col className="px-3 py-2 text-center">
                    <Highlighter
                      searchWords={[oLocation.sFilter]}
                      autoEscape={true}
                      textToHighlight={oLocation.name}
                    />
                  </Table.Col>
                  <Table.Col className="px-3 py-2 text-center hidden md:table-cell">
                    <Highlighter
                      searchWords={[oLocation.sFilter]}
                      autoEscape={true}
                      textToHighlight={oLocation.stateName}
                    />
                  </Table.Col>
                </Table.Row>
              ))
            ) : (
              <Table.Row>
                <Table.Col className="px-3 py-2 text-center" colSpan={3}>
                  <em>
                    {sFilter.length > 0
                      ? "No se encontraron resultados"
                      : "Sin localidades registradas"}
                  </em>
                </Table.Col>
              </Table.Row>
            )}
          </Table.Body>
        </Table>
      </section>
    </ScreenContainer>
  );
};

export default LocationsList;
